import { native } from '@forest/native-services'
import { cn } from '@forest/shared'
import { createEffect, createSignal, Show } from 'solid-js'
import coinSmall from '~/assets/coin-small.png'
import gemSmall from '~/assets/gem-small.png'

type Props = {
  coins: number
  gems: number
  loading?: boolean
}

function formatNumber(n: number) {
  return n.toLocaleString('en-US')
}

export function TopNav(props: Props) {
  const [coinBumped, setCoinBumped] = createSignal(false)
  const [gemBumped, setGemBumped] = createSignal(false)
  let prevCoins = props.coins
  let prevGems = props.gems

  createEffect(() => {
    if (props.coins > prevCoins) {
      setCoinBumped(true)
      window.setTimeout(() => setCoinBumped(false), 500)
    }
    prevCoins = props.coins
  })

  createEffect(() => {
    if (props.gems > prevGems) {
      setGemBumped(true)
      window.setTimeout(() => setGemBumped(false), 500)
    }
    prevGems = props.gems
  })

  return (
    <div class="fixed left-0 right-0 top-0 z-30 pt-[var(--safe-area-top)]">
      <div
        aria-hidden="true"
        class="pointer-events-none absolute inset-0 bg-[rgba(131,131,131,0.01)] backdrop-blur-[10px] [-webkit-mask-image:linear-gradient(to_bottom,black_0%,black_55%,transparent_100%)] [mask-image:linear-gradient(to_bottom,black_0%,black_55%,transparent_100%)]"
      />
      <div class="relative flex h-full items-end justify-between px-4 py-2">
        <CloseButton />

        {/* Balance */}
        <div class="pointer-events-none flex gap-2 py-1">
          <div
            aria-label={
              props.loading ? 'Coins loading' : `${props.coins} coins`
            }
            class="flex h-[26px] items-center justify-center gap-[4px] overflow-hidden rounded-full bg-black/20 px-[5px] py-[3px] text-sm text-white"
            classList={{ 'animate-pop': coinBumped() }}
          >
            <span
              data-coin-target="true"
              class="flex h-5 w-5 items-center justify-center"
            >
              <img src={coinSmall} alt="" class="h-5 w-5 object-contain" />
            </span>
            <Show
              when={!props.loading}
              fallback={
                <span
                  aria-hidden="true"
                  class="inline-block h-2.5 w-[31px] animate-pulse rounded-full bg-white/40"
                />
              }
            >
              <span class="tabular-nums leading-[20px]">
                {formatNumber(props.coins)}
              </span>
            </Show>
          </div>
          <div
            aria-label={props.loading ? 'Gems loading' : `${props.gems} gems`}
            class="flex h-[26px] items-center justify-center gap-[4px] overflow-hidden rounded-full bg-black/20 px-[5px] py-[3px] text-sm text-white"
            classList={{ 'animate-pop': gemBumped() }}
          >
            <span
              data-gem-target="true"
              class="flex h-5 w-5 items-center justify-center"
            >
              <img src={gemSmall} alt="" class="h-5 w-5 object-contain" />
            </span>
            <Show
              when={!props.loading}
              fallback={
                <span
                  aria-hidden="true"
                  class="inline-block h-2.5 w-[31px] animate-pulse rounded-full bg-white/40"
                />
              }
            >
              <span class="tabular-nums leading-[20px]">
                {formatNumber(props.gems)}
              </span>
            </Show>
          </div>
        </div>
      </div>
    </div>
  )
}

function CloseButton(props: { class?: string }) {
  return (
    <button
      class={cn('grid size-[42px] place-items-center', props.class)}
      onClick={() => {
        native.general.close()
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00012 5L15.0001 14.9999"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.00006 14.9999L15 5"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  )
}
